import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { CustomInfluenzaService } from 'src/app/custom-influenza/custom-influenza.service';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { ResourcesService } from 'src/app/tools-and-resources/resources.service';
import { CheckoutService } from '../checkout/checkout.service';

@Component({
  selector: 'app-receiving-hours-alert-banner',
  templateUrl: './receiving-hours-alert-banner.component.html',
  styleUrls: ['./receiving-hours-alert-banner.component.scss'],
})
export class ReceivingHoursAlertBannerComponent implements OnInit, OnDestroy {
  @Input() alertBannerShow: boolean = false;
  accountNumber: number;
  userDataSub: Subscription;
  userAccountgetData: any;
  accountSub: Subscription;
  userAccountDetailsSub: Subscription;
  userProfileSub: Subscription;
  receivingSub: Subscription;

  constructor(
    private readonly resourceService: ResourcesService,
    private readonly cd: ChangeDetectorRef,
    private readonly user: UserAccountFacade,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly checkoutService: CheckoutService,
    private readonly route: RoutingService,
    private readonly pfService: CustomProfileAndPreferencesService
  ) {}

  ngOnInit(): void {
    this.accountSub = this.pfService.userAccountDetails.subscribe(
      (response) => {
        this.getBanner(response);
      }
    );
    this.userAccountDetailsSub =
      this.influenzaService.userAccountDetails.subscribe((response) => {
        this.getBanner(response);
      });
    this.userProfileSub = this.pfService.userProfileAccountData.subscribe(
      (response) => {
        if (response) {
          this.getBanner(response);
        }
      }
    );
  }

  getBanner(response) {
    this.accountNumber = response?.res?.uid;
    let defaultAccountNo = JSON.parse(
      sessionStorage.getItem('defaultLocation')
    )?.[0]?.accountNumber;
    if (
      (this.accountNumber && +this.accountNumber !== +defaultAccountNo) ||
      (+this.accountNumber === +defaultAccountNo &&
        JSON.parse(sessionStorage.getItem('defaultLocInList')))
    ) {
      if (response?.res?.customerSalesAreaData?.deliveryHours?.length > 0) {
        this.alertBannerShow =
          !response?.res?.customerSalesAreaData?.deliveryHours.some(
            (element) => element.fromTime != 'Closed'
          );
      } else {
        this.alertBannerShow = true;
      }
      this.cd.detectChanges();
    }

    this.receivingSub = this.pfService.receivingHoursUpdated.subscribe(
      (res) => {
        if (res) {
          this.alertBannerShow = true;
          this.cd.detectChanges();
        } else {
          this.alertBannerShow = false;
          this.cd.detectChanges();
        }
      }
    );
    if (this.alertBannerShow) {
      this.influenzaService.deliveryHoursAlertBanner.next(true);
    } else {
      this.influenzaService.deliveryHoursAlertBanner.next(false);
    }
  }

  goToProfileAccount() {
    this.route.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Address(s) of Business Unit(s)');
  }

  closeBanner() {
    this.alertBannerShow = false;
  }

  ngOnDestroy(): void {
    this.accountSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.userProfileSub?.unsubscribe();
    this.receivingSub?.unsubscribe();
  }
}
